export default __webpack_public_path__ + "static/media/real_time_updates.4fb976d6.svg";